/* unplugin-vue-components disabled */import script from "./OrderAudit@3.0.vue?vue&type=script&setup=true&lang=js"
export * from "./OrderAudit@3.0.vue?vue&type=script&setup=true&lang=js"

import "./OrderAudit@3.0.vue?vue&type=style&index=0&id=5bc08929&lang=scss"

const __exports__ = script;

export default __exports__